import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { leadsActions } from '../ActionTypes';


export const fetchLeads = () => async (dispatch) => {
  try {
    dispatch({
      type: leadsActions.LEADS_FETCH_START
    });
    const resData = await Service.GET({
      name: 'leads',
      queryString: null
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: leadsActions.LEADS_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: leadsActions.LEADS_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};

// get CoursesPage
export const fetchCourses = () => async (dispatch) => {
  try {
    dispatch({
      type: leadsActions.LEADS_COURSES_FETCH_START
    });

    const resData = await Service.GET({
      name: 'course-page',
      queryString: ''
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: leadsActions.LEADS_COURSES_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: leadsActions.LEADS_COURSES_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};


// get Admins
export const fetchAdmins = () => async (dispatch) => {
  try {
    dispatch({
      type: leadsActions.LEADS_ADMINS_FETCH_START
    });
    const resData = await Service.GET({
      name: 'admins',
      queryString: '?excludeRoleType=admin'
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: leadsActions.LEADS_ADMINS_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: leadsActions.LEADS_ADMINS_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};


export const editLeads = (leadId) => async (dispatch) => {
  try {
    const data = await Service.GET({
      name: 'leads',
      queryString: `leadId=${leadId}`
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: leadsActions.LEADS_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};

export const saveStatus = (formData) => async (dispatch) => {
  try {
    const payload = { ...formData, followUpDate: `${formData.followUpDate}T06:30:00.000Z` };
    if (typeof formData.followUpDate === 'undefined') {
      delete payload.followUpDate;
    }
    dispatch({
      type: leadsActions.LEADS_STATUS_SAVE_START
    });
    await Service.PUT({
      name: 'leads/status',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: leadsActions.LEADS_STATUS_SAVE_SUCCESS
    });
    dispatch(editLeads(formData.leadId));

    toast.success('Saved Successfully');
  } catch (error) {
    dispatch({
      type: leadsActions.LEADS_STATUS_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};


export const saveLeads = (formData) => async (dispatch) => {
  try {
    const Course = formData.Course ? formData.Course.split('~') : null;

    const payload = {
      ...formData,
      Course
    };
    dispatch({
      type: leadsActions.LEADS_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'leads',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: leadsActions.LEADS_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/leads'; }, 1000);
  } catch (error) {
    dispatch({
      type: leadsActions.LEADS_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};


export const resetForm = () => (dispatch) => dispatch({ type: leadsActions.LEADS_RESET_FORM });

export const deleteLeads = (Id) => async (dispatch) => Service.DELETE({
  name: 'leads',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchLeads());
    return true;
  }
  throw new Error(res.message);
});
